var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "slider-item",
      class: [
        "slider-item-" + (_vm.iterator + 1),
        { "top-ten-item": _vm.section === "tmu" }
      ],
      on: { mouseenter: _vm.onHoverStart, mouseleave: _vm.onHoverEnd }
    },
    [
      _vm.gameInfoData &&
      _vm.gameInfoData.labels &&
      _vm.gameInfoData.labels.length > 0
        ? _c("casino-labels", {
            staticClass: "casino-labels",
            attrs: { labels: _vm.gameInfoData.labels }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoggedIn
        ? _c("casino-favorites", {
            attrs: { favorite: _vm.isFavorite, gameId: _vm.gameId }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("casino-game-image", { attrs: { gameId: _vm.gameId } }),
      _vm._v(" "),
      _vm.section && _vm.section === "tmu"
        ? _c("div", {
            class: [
              { "top-ten": _vm.section === "tmu" },
              "top-" + (_vm.iterator + 1),
              "top-image"
            ],
            on: {
              click: function($event) {
                return _vm.startCasinoLauncher(_vm.gameId)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("casino-jackpot-and-game-info-section", {
        attrs: { gameId: _vm.gameId, section: _vm.section }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f5501ef", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f5501ef","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/igaming/partials/casinoSliderItem.vue
// module id = null
// module chunks = 